import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=106a8e52&"
import script from "./AppButton.vue?vue&type=script&lang=ts&"
export * from "./AppButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
